module.exports = __webpack_public_path__ + "img/toroid-purple.1dc20cbb.png";